import { TokenSymbol } from 'modules/common/types/TokenSymbol';
import { ReactComponent as EthereumIcon } from '../assets/ethereum.svg';
import { ReactComponent as BaseIcon } from '../assets/base.svg';

import {
  BlockchainNetworkId,
  getBlockChainExplorerAddress,
} from 'modules/common/conts';
import { t } from 'modules/i18n/utils/intl';

export type ChainType = BlockchainNetworkId.mainnet | BlockchainNetworkId.goerli | BlockchainNetworkId.baseTestnet | BlockchainNetworkId.baseMainnet;

export const getChainConfig = (tarChain: ChainType) => {
  const chainList: {
    [key in ChainType]: any;
  } = {
    [BlockchainNetworkId.mainnet]: {
      icon: <EthereumIcon />,
      title: t('header.select-chain.eth'),
      subTitle: '',
      chainConfig: {
        chainId: '0x1',
        chainName: 'Ethereum Chain Mainnet',
        nativeCurrency: {
          name: 'Ethereum',
          symbol: TokenSymbol.ETH,
          decimals: 18,
        },
        rpcUrls: [
          'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
        ],
        blockExplorerUrls: [
          getBlockChainExplorerAddress(BlockchainNetworkId.mainnet),
        ],
      },
    },
    [BlockchainNetworkId.goerli]: {
      icon: <EthereumIcon />,
      title: 'Sepolia',
      subTitle: '',
      chainConfig: {
        chainId: '0xaa36a7',
        chainName: 'Sepolia',
        nativeCurrency: {
          name: 'Ethereum',
          symbol: TokenSymbol.ETH,
          decimals: 18,
        },
        rpcUrls: ['https://rpc.ankr.com/eth_sepolia'],
        blockExplorerUrls: ['https://sepolia.etherscan.io/'],
      },
    },
    [BlockchainNetworkId.baseTestnet]: {
      icon: <BaseIcon />,
      title: t('header.select-chain.base-testnet'),
      subTitle: '',
      chainConfig: {
        chainId: '0x14a34',
        chainName: 'Base Sepolia Testnet',
        nativeCurrency: {
          "name": "Base Sepolia Testnet",
          "symbol": TokenSymbol.ETH,
          "decimals": 18
        },
        rpcUrls: ["https://rpc.notadegen.com/base/sepolia"],
        blockExplorerUrls: ["https://sepolia.basescan.org/"],
      },
    },
    [BlockchainNetworkId.baseMainnet]: {
      icon: <BaseIcon />,
      title: t('header.select-chain.base-mainnet'),
      subTitle: '',
      chainConfig: {
        chainId: '0x2105',
        chainName: 'Base Mainnet',
        nativeCurrency: {
          "name": "Base Mainnet",
          "symbol": TokenSymbol.ETH,
          "decimals": 18
        },
        rpcUrls: ["https://developer-access-mainnet.base.org"],
        blockExplorerUrls: ["https://basescan.org/"],
      },
    },
    
  };

  return chainList[tarChain];
};
